module.exports = __webpack_public_path__ + "img/add-item.67f85cfa.svg";